export enum DataConfigurationType {
  Array = 'array',
  Boolean = 'boolean',
  Date = 'date',
  Number = 'number',
  Object = 'object',
  String = 'string',
}

export interface IBaseDataConfiguration {
  description?: string;
}

export interface IPrimitiveDataConfiguration extends IBaseDataConfiguration {
  type: Exclude<DataConfigurationType, DataConfigurationType.Array | DataConfigurationType.Object>;
}

export interface IArrayDataConfiguration extends IBaseDataConfiguration {
  items: DataConfiguration;
  type: DataConfigurationType.Array;
}

export interface IObjectDataConfiguration extends IBaseDataConfiguration {
  properties: Record<string, DataConfiguration>;
  type: DataConfigurationType.Object;
}

export type DataConfiguration = IArrayDataConfiguration | IObjectDataConfiguration | IPrimitiveDataConfiguration;

export const nonPrimitiveTypes = [DataConfigurationType.Array, DataConfigurationType.Object];
